// extracted by mini-css-extract-plugin
export default {"wrapper":"_1K-u","header":"_3X1G","title":"_3VZF","subtitle":"yb-U","icon":"_1iii","appstoreLinks":"_3xuR","link":"_2PhM","appStore":"_3VxD","googlePlay":"_1Lig"};